'use client'
import { Splide } from '@splidejs/react-splide'
import { FC } from 'react'

type FundListCarouselProps = {
  children: React.ReactNode
  options?: object
}

export const FundListCarousel: FC<FundListCarouselProps> = ({ children, options }) => {
  const splide_options = {
    ...{
      perPage: 1,
      arrows: true,
      gap: 16,
      pagination: true,
      padding: { left: '0rem', right: '2rem' },
      classes: {
        pagination: 'splide__pagination !bottom-[-30px]',
      },
    },
    ...options,
  }

  return <Splide options={splide_options}>{children}</Splide>
}
